import { useCallback, useEffect, useState } from 'react';

const PREFIX = 'coach_seen:';

export function useFirstVisit(key: string) {
  const storageKey = PREFIX + key;
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(storageKey) !== '1') setShouldShow(true);
    } catch { /* ignore */ }
  }, [storageKey]);

  const dismiss = useCallback(() => {
    try { localStorage.setItem(storageKey, '1'); } catch { /* ignore */ }
    setShouldShow(false);
  }, [storageKey]);

  return { shouldShow, dismiss };
}

export function resetCoachMark(key: string) {
  try { localStorage.removeItem(PREFIX + key); } catch { /* ignore */ }
}

export function resetAllCoachMarks() {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX)) localStorage.removeItem(k);
    }
  } catch { /* ignore */ }
}
